<template>

  <div>

    <div :id="_uid" class="ui small modal" :class="modalSelector">
      <div class="ui header">
        {{ isCreating ? "Nova Natureza Financeira" : "Alterar Natureza Financeira" }}
      </div>
      <div class="content">
        <div class="ui form">
          <div class="fields">
            <div class="sixteen wide field">
              <label class="form-label">Descrição <span class="red text">*</span></label>
              <input class="uppercase" v-model="nature.description" @blur="nature.description = $toUpperCase($event)">
            </div>     
          </div>
          <div v-show="isCreating" class="fields">
            <div class="sixteen wide field">
              <label class="form-label">
                Tipo 
                <span class="red text">*</span>
              </label>
              <select-dropdown ref="typeDropdown" @onChange="onChangeType" />
            </div>     
          </div>
          <div v-if="isUpdating" class="fields">
            <div class="sixteen wide field">
              <label class="form-label">
                Tipo <i :class="typeIcon.icon" style="margin-left: 2px;"></i>
              </label>
              <input :value="typeIcon.description" readonly="readonly">
            </div>     
          </div>
        </div>
      </div>
      <div class="actions">
        <button class="ui cancel basic button">
          <i class="times icon"></i>
          Cancelar
        </button>      
        <button v-if="isUpdating" class="ui basic red button" 
          :class="{ loading: checkingRemoval || removing }" @click="onRemove()">
          <i class="trash icon"></i> Excluir
        </button>
        <button class="ui blue button" :class="{ loading: saving, disabled: !canConfirm }" @click="onConfirm()">
          <i class="checkmark icon"></i>
          {{ isCreating ? "Confirmar" : "Atualizar" }}
        </button>
      </div>
    </div>

    <can-not-remove-modal ref="canNotRemoveModal" />

    <yes-no-modal ref="confirmRemovalModal" :message="'Confirma exclusão da natureza ' + nature.description + ' ?'" 
      :danger="true" @onYes="onConfirmRemoval()"/>

  </div>
  
</template>

<script>

  import modalDialog from "@/mixins/modal-dialog"  
  import FinancialNatureService from "@/services/financial-nature-service"
  import SelectDropdown from "@/components/select-dropdown"

  export default {

    name: "FinancialNatureFormModal",

    mixins: [modalDialog],

    components: {
      SelectDropdown,
    },

    data() {
      return {
        nature: {},
        service: new FinancialNatureService(),
      }
    },

    computed: {

      typeIcon() {

        if (!this.nature.type)
          return {}

        return FinancialNatureService.TYPE_ICONS[this.nature.type]
      },

      canConfirm() {

        const { description, type } = this.nature

        return (description && type && !this.removing)
      },
    },
    
    methods: {

      load(nature) {

        this.nature = {}

        if (nature)
          this.nature = this.$cloneObject(nature)

        this.show()
      },

      onShow() {        
        this.loadTypeDropdown()
      },

      loadTypeDropdown() {

        if (this.isUpdating)
          return

        let typeList = []
        const TYPE_ICONS = FinancialNatureService.TYPE_ICONS

        for (let prop in TYPE_ICONS) {
          if (TYPE_ICONS.hasOwnProperty(prop)) {
            typeList.push({
              id: prop,
              value: `<i class="${TYPE_ICONS[prop].icon}"></i> ` + TYPE_ICONS[prop].description
            })
          }
        }

        this.$refs.typeDropdown.setValues(typeList, this.nature.type)
      },

      onChangeType(type) {
        this.nature.type = type
        this.nature = this.$cloneObject(this.nature)
      },

      async onConfirm() {

        if (this.saving)
          return

        this.saving = true
        
        try {

          if (this.isCreating) {
            await this.service.create(this.nature)
          } else {            
            await this.service.update(this.nature)            
          }

          this.emit("onSave", this.nature)

          this.$msg.success(this.isCreating ? "Natureza criada com sucesso" : "Natureza alterada com sucesso")
          
        } catch (error) {

          this.$errorHandler(error)

        } finally {

          this.saving = false
        }
      },

      async onRemove() {

        this.checkingRemoval = true

        try {

          const data = await this.service.canRemove(this.nature)

          if (data.canRemove)  {
            this.$refs.confirmRemovalModal.show()              
          } else {
            this.$refs.canNotRemoveModal.show(data.entities)            
          }

        } catch (error) {

          this.$errorHandler(error)

        } finally {

          this.checkingRemoval = false
        }        
      },

      async onConfirmRemoval() {

        if (this.removing)
          return

        this.removing = true

        try {

          await this.service.remove(this.nature) 

          this.emit("onRemove", this.nature)

          this.$msg.success("Natureza excluída com sucesso")
          
        } catch (error) {

          this.$errorHandler(error)

        } finally {

          this.removing = false
        }
      },
    },
  }

</script>
